<template>
  <ion-list lines="full" class="inline-list">
    <ion-item>
      <ion-toggle aria-label="Виден другим" :checked="privacy.discoverable" @ionChange="update('discoverable', $event.detail.checked)">
        Виден другим
      </ion-toggle>
    </ion-item>
    <ion-item>
      <ion-select
        label="Личные сообщения"
        label-placement="stacked"
        :value="privacy.dmPolicy"
        interface="popover"
        @ionChange="update('dmPolicy', $event.detail.value)"
      >
        <ion-select-option value="NOBODY">Нельзя писать</ion-select-option>
        <ion-select-option value="REQUESTS">Только по запросу</ion-select-option>
        <ion-select-option value="EVERYONE">Можно писать всем</ion-select-option>
      </ion-select>
    </ion-item>
  </ion-list>
</template>

<script lang="ts">
import { IonItem, IonList, IonSelect, IonSelectOption, IonToggle } from '@ionic/vue';
import { defineComponent, PropType } from 'vue';
import { IMessengerPrivacy } from '@/services/messenger.service';

export default defineComponent({
  name: 'MessengerPrivacySettingsInline',
  components: { IonItem, IonList, IonSelect, IonSelectOption, IonToggle },
  props: { privacy: { type: Object as PropType<IMessengerPrivacy>, required: true } },
  emits: ['change'],
  methods: {
    update(key: keyof IMessengerPrivacy, value: any) {
      this.$emit('change', { ...this.privacy, [key]: value });
    },
  },
});
</script>

<style scoped>
.inline-list {
  background: transparent;
}
.inline-list ion-item {
  --background: transparent;
  --color: var(--liga-chrome-text);
  --border-color: var(--liga-surface-border);
}
.inline-list ion-toggle,
.inline-list ion-select {
  --color: var(--liga-chrome-text);
  color: var(--liga-chrome-text);
}
</style>
